import "./App.css";
import { RouterProvider } from "react-router-dom";
import { routes } from "./variables/routes";
import "./styles.scss";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <div>
      <RouterProvider router={routes} />

      <Toaster position="bottom-right" reverseOrder={false} />
    </div>
  );
}

export default App;
